<template>
    <div v-if="products && products.length" class="grid grid-cols-2 lg:grid-cols-6 xl:grid-cols-10 gap-4">
        <div v-for="product in products" :key="`product-${product.id}`" class="col-sppan-1 lg:col-span-2 h-full">
            <div class="h-full">
                <ProductCard
                    :title="product.name"
                    :parameter="product?.parameters"
                    :rating="3.5"
                    :product="product"
                    :slug="
                        localePath({
                            name: 'products-category-product',
                            params: {
                                category: product?.category_slug,
                                product: product?.slug,
                            },
                        })
                    "
                    class="h-full"
                    :brutto-price="product.price"
                    :is-favorite="product.isFavorite"
                    :price="product.price"
                    :discounted-price="product.discounted_price"
                    :image="product.category_name === 'Whispers of Wood' ? product.image : product.preview"
                    md
                />
            </div>
        </div>
    </div>
    <div v-else class="text-center mb-12 lg:mb-0 flex flex-col items-center justify-center h-full mt-16">
        <i class="sad-emoji mb-3" data-not-lazy></i>
        <h4 class="font-Inter-Bold text-xl lg:text-[1.5rem] mb-4 leading-[2rem]" v-html="$t('products.no_results_title')"></h4>
        <p class="lg:w-8/12 text-sm lg:text-base">
            {{ $t('products.no_results_text') }}
        </p>
    </div>
</template>

<script>
import ProductCard from '@/components/Cards/ProductCard/ProductCard.vue';
export default {
    name: 'ProductGrid',
    components: {
        ProductCard,
    },
    props: {
        products: {
            type: Array,
            required: true,
        },
        productCount: {
            type: Number,
            required: false,
            default: 10,
        },
    },
    data() {
        return {
            count: 10,
        };
    },
    mounted() {
        this.count = this.productCount;
    },
    methods: {
        loadMoreProducts() {
            if (this.products.length > this.count) {
                this.count = this.count + 5;
            }
        },
    },
};
</script>
